import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button } from 'rsuite';
import GuestSearch from '../../../containers/GuestSearch';
import { RELATION_SEARCH } from '../../../constants/custom-list/Types';

const SearchGuestRelationModal = props => {
  const { show, onHide } = props;
  const handleShow = () => {};

  const handleSelectGuest = item => {
    const { onSelect } = props;
    onSelect(item);
  };

  return (
    <Modal overflow size="md" show={show} onHide={onHide} onShow={handleShow}>
      <Modal.Header>
        <Modal.Title>Search Guests</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <GuestSearch
          hideCreate
          type={RELATION_SEARCH}
          onSelectGuest={handleSelectGuest}
          showBarcodeSearch={false}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={onHide} appearance="subtle">
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

SearchGuestRelationModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func,
  onSelect: PropTypes.func
};

SearchGuestRelationModal.defaultProps = {
  onHide: () => {},
  onSelect: () => {}
};

export default SearchGuestRelationModal;
